export const avatarPlaceholderBgColors = ['#A0D8DC', '#9AB0FF', '#FFCFA2'];

export const avatarPlaceholderColors = ['#1D5846', '#072E78', '#5F4C2B'];

export const getRandomLetter = () => {
  return String.fromCharCode(65 + Math.floor(Math.random() * 26));
};
